module.exports = __webpack_public_path__ + "static/media/bulb.acd697cd.ico";